;'use strict';

const $mobileMenuBtn = $('.mm__open-menu');
const $mobileToggleNav = $('.mobile--menu');
const $aislesToggleNav = $('.aisles--menu');
const $shopInshopToggleNav = $('.shop-in-shop--menu');
const $body = $('body');

const mainMenuNav = function () {
    const _closeMenuNav = function (mobileMenu) {
        $body.removeClass('overflow-hidden');
        $('.aisles--btn').attr('aria-expanded', false);
        $('.shop-in-shop--btn').attr('aria-expanded', false);
        $mobileMenuBtn.attr('aria-expanded', false).removeClass('active');
        $('.nav-overlay').remove();
        $('.sub-nav-head').removeClass('three-col');
        $('.sub-nav-head').removeClass('two-col');
        $('.aisles--subNav--lev2').empty();
        $('.aisles--subNav--lev3').empty();
        $('.active--nav').removeClass('active--nav');
        $('.btn-display-aisle').attr('aria-expanded', false);
        $('.hide-overflow').removeClass('hide-overflow');

        if (typeof $aislesToggleNav !== 'undefined' && $aislesToggleNav.length > 0) {
            $aislesToggleNav.removeClass('active');
            $aislesToggleNav.addClass('inactive');
            $aislesToggleNav.prop('inert', true);
        }

        if (typeof $shopInshopToggleNav !== 'undefined' && $shopInshopToggleNav.length > 0) {
            $shopInshopToggleNav.removeClass('active');
            $shopInshopToggleNav.addClass('inactive');
            $shopInshopToggleNav.prop('inert', true);
        }
        if (mobileMenu != false) {
            $mobileToggleNav.removeClass('active');
            $mobileToggleNav.addClass('inactive');
            $mobileToggleNav.prop('inert', true);
        }
    }
    return {
        closeMenuNav: _closeMenuNav,
    }
}();

$(document).ready(function () {
    const $navCoreLink = $('.container__bottom a, .container__bottom button');
    $navCoreLink.each(function () {
        let $this = $(this);
        let isCoreLink = $this.data('core-link');
        if (isCoreLink) {
            $this.closest('li').addClass('nav--core-link');
        }
    });

    const manageCloseNavOverlay = function () {
        $('.nav-overlay').on('click', function (e) {
            if (e.target === this) {
                mainMenuNav.closeMenuNav();
            }
        });
    }

    const showToggleMenu = function (elm, toggleType, toggleTab) {
        $('.nav-overlay').remove();
        $body.addClass('overflow-hidden');
        mainMenuSticky.disabledSticky();
        $mobileMenuBtn.addClass('active').attr('aria-expanded', true);
        toggleTab.addClass('active');
        toggleTab.removeClass('inactive');
        toggleTab.prop('inert', false);
        $mobileToggleNav.find('.nav--container').scrollTop(0);
        if (toggleType === 'aisles') {
            elm.attr('aria-expanded', true);
            $('.shop-in-shop--menu').removeClass('active');
            $('.shop-in-shop--btn').attr('aria-expanded', false);
            $mobileToggleNav.addClass('active');
            $mobileToggleNav.removeClass('inactive');
            $mobileToggleNav.prop('inert', false);
            $aislesToggleNav.append('<span class="nav-overlay" />');
            $aislesToggleNav.find('.nav--container').scrollTop(0);
        } else if (toggleType === 'shop-in-shop') {
            elm.attr('aria-expanded', true);
            $('.aisles--menu').removeClass('active');
            $('.aisles--btn').attr('aria-expanded', false);
            $mobileToggleNav.addClass('active');
            $mobileToggleNav.removeClass('inactive');
            $mobileToggleNav.prop('inert', false);
            $shopInshopToggleNav.append('<span class="nav-overlay" />');
            $shopInshopToggleNav.prop('inert', false);
            $mobileToggleNav.find('.nav--container').scrollTop(0);
        } else {
            $mobileToggleNav.append('<span class="nav-overlay" />');
        }
        if (Revealizr.isDesktopSize) {
            $('.navigation__btn--close').focus();
            let $lastAisleElm = $('.menu-toggle-nav.active').find('li').last();
            headerMenuAisle.aisleMenuFocusTrap($lastAisleElm);
        }
        manageCloseNavOverlay();
    };

    const closeLoginPanel = function () {
        if ($('.login-side-panel.remodal-is-opened').length > 0) {
            $(".login-side-panel").remodal().close();
        }
    };

    $('.aisles--btn').click(function () {
        let $this = $(this);
        closeLoginPanel();
        if ($this.attr('aria-expanded') === 'false') {
            showToggleMenu($this, 'aisles', $aislesToggleNav);
        } else {
            mainMenuNav.closeMenuNav();
        }
    });

    $('.shop-in-shop--btn').click(function () {
        let $this = $(this);
        if ($this.attr('aria-expanded') === 'false') {
            showToggleMenu($this, 'shop-in-shop', $shopInshopToggleNav);
        } else {
            mainMenuNav.closeMenuNav();
        }
    });

    $('.link-confirmation').click(function (event) {
        if (!isAuthenticated) {
            loginSidePanel();
            event.preventDefault();
            return false;
        }
    });

    $mobileMenuBtn.click(function () {
        let $this = $(this);
        if ($this.attr('aria-expanded') === 'false') {
            showToggleMenu($this, 'mobileNav', $mobileToggleNav);
        } else {
            mainMenuNav.closeMenuNav();
        }
    });

    $('.navigation__btn--close').click(function () {
        mainMenuNav.closeMenuNav();
    });

    $('.aisles--lvl-1').click(function () {
        mainMenuNav.closeMenuNav(true);
        showToggleMenu(false, 'mobileNav', $mobileToggleNav);
    });

    $('.aisles--lvl-2').click(function () {
        $('.sub--nav--second').removeClass('active--nav');
        $('.btn-display-aisle').attr('aria-expanded', false);
        $('.sub--nav--first').removeClass('hide-overflow');
    });

    $('.aisles--lvl-3').click(function () {
        $('.sub--nav--third').removeClass('active--nav');
        $('.active--sub-nav').removeClass('active--sub-nav');
        $('.sub--nav--second').removeClass('hide-overflow');
    });
});

var defaultPublicity = {};
$(document).ready(function () {
    var $burgerMenu = $('.header-menu-primary');
    var containsPublicity = $burgerMenu.has('.hsm__ad');
    if (containsPublicity) {
        defaultPublicity.linkHref = $burgerMenu.find('.hsm__ad a').attr('href');
        defaultPublicity.linkTitle = $burgerMenu.find('.hsm__ad a').attr('title');
        defaultPublicity.linkOnclick = $burgerMenu.find('.hsm__ad a').attr('onclick');
        defaultPublicity.linkGaType = $burgerMenu.find('.hsm__ad a').attr('data-ga-type');
        defaultPublicity.imgSrc = $burgerMenu.find('.hsm__ad a img').attr('src');
        defaultPublicity.imgAlt = $burgerMenu.find('.hsm__ad a img').attr('alt');
        defaultPublicity.imgStyle = $burgerMenu.find('.hsm__ad a img').attr('style');
    }
});

function updatePublicity(open, pathBigMenuEn) {
    var $burgerMenu = $('.header-menu-primary');
    var containsPublicity = $burgerMenu.has('.hsm__ad');
    if (open && pathBigMenuEn) {
        var $firstPublicity = $('#main-menu .mn--' + pathBigMenuEn + ' .mn--ads .mn--ad a').first();
        if ($firstPublicity.length) {
            if (!containsPublicity.length) {
                $burgerMenu.append('<div class="hsm__ad padding-medium"><span><a><img alt=""></a></span></div>');
            }
            $burgerMenu.find('.hsm__ad a').attr('href', $firstPublicity.attr('href'));
            $burgerMenu.find('.hsm__ad a').attr('title', $firstPublicity.attr('title'));
            $burgerMenu.find('.hsm__ad a').attr('onclick', $firstPublicity.attr('onclick'));
            $burgerMenu.find('.hsm__ad a').attr('data-ga-type', $firstPublicity.attr('data-ga-type'));
            $burgerMenu.find('.hsm__ad a img').attr('src', $firstPublicity.find('img').attr('src'));
            $burgerMenu.find('.hsm__ad a img').attr('alt', $firstPublicity.find('img').attr('alt'));
            $burgerMenu.find('.hsm__ad a img').attr('style', $firstPublicity.find('img').attr('style'));
        }
    } else if (!open) {
        if (defaultPublicity.imgSrc !== undefined) {
            $burgerMenu.find('.hsm__ad a').attr('href', defaultPublicity.linkHref);
            $burgerMenu.find('.hsm__ad a').attr('title', defaultPublicity.linkTitle);
            $burgerMenu.find('.hsm__ad a').attr('onclick', defaultPublicity.linkOnclick);
            $burgerMenu.find('.hsm__ad a').attr('data-ga-type', defaultPublicity.linkGaType);
            $burgerMenu.find('.hsm__ad a img').attr('src', defaultPublicity.imgSrc);
            $burgerMenu.find('.hsm__ad a img').attr('alt', defaultPublicity.imgAlt);
            $burgerMenu.find('.hsm__ad a img').attr('style', defaultPublicity.imgStyle);
        } else {
            $burgerMenu.find('.hsm__ad').remove();
        }
    }
}

// Big menu
$(document).on('click', '.dataLayerBigMenuLevelTwo', function () {
    const subMenuLabel = ($(this).data('sub-menu-name') != undefined) ? $(this).data('sub-menu-name').trim().toLowerCase() : 'undefined';
    pushDataLayerBigMenuLevel('big_menu', subMenuLabel);
    $(this).focus();
});